import React from 'react'
import { Col, Row } from 'react-bootstrap'

export const AuditLogSearchInfoBox: React.FC = () => {
  return (
    <Row className='p-3 zocks-bg-color-primary-light gap-3 justify-content-center rounded w-100 m-0 mb-3'>
      <Col className='d-flex align-items-center zocks-gap-2.5 align-self-center'>
        <div className='d-flex align-self-center gap-3 align-items-center'>
          <i className='bi bi-info-square zocks-text-primary fs-5' />
          <span className='zocks-text-gray-900'>
            Quick search looks into the first 50,000 records. Use the filter option on the left-hand side panel for accurate searches.
          </span>
        </div>
      </Col>
    </Row>
  )
}
